<template>
  <div class="side-menu next">
    <ul class="list-group custom-inline-box">
      <li class="list-group-item active"><span style="margin-top: 5px; display: inline-block;">Floor Range</span>    <a @click="$bvModal.show('modal-arial-view')" href="javascript:void(0)"  class="btn-aerial">Watch Aerial View</a></li>
      <li class="list-group-item list-group-item-action" v-for="floor in floors">
        <div class="custom-control custom-radio ">
          <input type="radio" :id="floor.key" name="floorSelector" class="custom-control-input" @click="selectFloor(floor)" :checked="selectedFloor !== null && floor.key === selectedFloor.key">
          <label class="custom-control-label" :for="floor.key">{{floor.value}}</label>
        </div>
      </li>
      <li class="list-group-item">
        <p class="small">*Price includes GST, Stamp Duty, Registration charges. It does not include Maintenance.</p>
        <div class="mbtn-align">
        <button type="button" class="btn btn-primary prevButton"><svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
    viewBox="0 0 512 512" style="enable-background:new 0 0 512 512;" xml:space="preserve">
  <g>
    <g>
      <path d="M501.333,245.333H36.417l141.792-141.792c4.167-4.167,4.167-10.917,0-15.083c-4.167-4.167-10.917-4.167-15.083,0l-160,160
        c-4.167,4.167-4.167,10.917,0,15.083l160,160c2.083,2.083,4.813,3.125,7.542,3.125c2.729,0,5.458-1.042,7.542-3.125
        c4.167-4.167,4.167-10.917,0-15.083L36.417,266.667h464.917c5.896,0,10.667-4.771,10.667-10.667S507.229,245.333,501.333,245.333z
        "/>
    </g>
  </g>
  </svg></button>
        <span class="d-inline-block" tabindex="0" data-toggle="tooltip" title="Please Select a Floor Range">
          <button type="button" class="btn btn-primary " :disabled="!selectedFloor.key" @click="goToPlans">Proceed</button>
        </span>
        </div>
      </li>
      
    </ul>
  </div>
</template>
<script>
import {masterJson} from '@/assets/scripts/utility.js'
export default {
  methods: {
    selectFloor(floor){
      this.$store.dispatch('setFloor', floor);
    },
    goToPlans(){
      this.$router.push({name: 'Plans', params: {typology: this.selectedTypology.key, floor: this.selectedFloor.key}})
    }
  },
  computed: {
    floors(){
      return masterJson.Floors;
    },
    selectedFloor(){
      return this.$store.getters.selectedFloor;
    },
    selectedTypology(){
      return this.$store.getters.selectedTypology;
    }
  }
}
</script>